import React from "react";
import { MdDone } from "react-icons/md";
import { useNavigate } from "react-router-dom";

const OrderCompleted = () => {
    const navigate = useNavigate();
    return (
        <div className="px-2 sm:px-4 lg:px-8 py-7 h-full overflow-hidden">
            <div className="bg-white w-full h-full flex justify-center items-center rounded-lg">
                <div className="min-w-[258px] max-w-[516px] mx-auto">
                    <div className="w-[74px] aspect-square rounded-full flex justify-center items-center border-4 border-purple-color mb-5 mx-auto">
                        <MdDone className="text-purple-color text-[40px]" />
                    </div>
                    <div className="mb-5 text-center">
                        <h3 className="text-xl sm:text-2xl font-bold text-ebony-color mb-2">
                            Your purchase is successful
                        </h3>
                        <p className="text-sm sm:text-base font-medium text-black-60 ">
                            Your order was completed successfuly.
                        </p>
                        <button
                            onClick={() => navigate("/page/order")}
                            type="button"
                            class="inline-flex my-4 items-center justify-center rounded-lg px-4 py-3 transition duration-500 ease-in-out text-white bg-blue-500 hover:bg-blue-400 focus:outline-none"
                        >

                            See my order
                        </button>
                    </div>
                    {/* <div className="relative">
                        <input
                            type="text"
                            className="py-[9px] px-[13px] w-full text-sm text-black-60 hover:text-purple-color rounded-md border border-[#D1D5DB] modal-input-shadow outline-none cursor-default caret-transparent"
                            value="KZP1rd"
                            id="referral-code"
                            placeholder="Tr. ID: efj125gtxdsdr589ds"
                        />
                        <span className="text-black-50 hover:text-purple-color text-lg cursor-pointer absolute top-2/4 right-1.5 -translate-y-2/4">
                            <svg
                                width="13"
                                height="13"
                                className="stroke-current"
                                viewBox="0 0 13 13"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M3.83268 8.83887H2.49935C1.76297 8.83887 1.16602 8.24191 1.16602 7.50553V2.1722C1.16602 1.43582 1.76297 0.838867 2.49935 0.838867H7.83268C8.56906 0.838867 9.16602 1.43582 9.16602 2.1722V3.50553M5.16602 11.5055H10.4993C11.2357 11.5055 11.8327 10.9086 11.8327 10.1722V4.83887C11.8327 4.10249 11.2357 3.50553 10.4993 3.50553H5.16602C4.42964 3.50553 3.83268 4.10249 3.83268 4.83887V10.1722C3.83268 10.9086 4.42964 11.5055 5.16602 11.5055Z"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </span>
                    </div> */}
                </div>
            </div>
        </div>
    );
};

export default OrderCompleted;
